<template>
  <div id="incidents-popup" class="flex w-full grow flex-col gap-4 overflow-y-auto p-4">
    <div class="flex justify-between gap-2">
      <div class="flex flex-1 gap-4">
        <div class="flex items-center">
          <img class="size-10" :src="selectedIncident?.icon" alt="" />
        </div>
        <div class="flex flex-1 flex-col">
          <div class="text-wrap text-xl font-medium text-type-primary">
            {{ selectedIncident?.title }}
          </div>
          <div class="text-base text-type-secondary">
            {{ selectedIncident?.description }}
          </div>
          <div class="text-xs font-medium text-type-secondary"><ui-relative-time :time="selectedIncident?.updatedAt" /></div>
        </div>
      </div>

      <button
        v-if="!hideCloseButton"
        class="flex size-6 min-h-6 min-w-6 cursor-pointer items-center justify-center"
        @click="mapStore.closePopup()"
      >
        <close-rounded aria-label="Close" class="*:fill-type-primary" />
      </button>
    </div>

    <div class="h-px w-full bg-grey-35"></div>

    <ui-incident-content />

    <ui-map-popup-footer v-if="showFooter" :left-text="t('lSeWusNweldd_c1g_1aJb')" :left-callback="zoomToFeatures" />
  </div>
</template>

<script setup lang="ts">
import CloseRounded from '@/common/assets/icons/close-rounded.svg';
import { useHazardsStore, useMapStore } from '@/features/hazards';
import { i18n } from '@/locales';
import { computed, watch } from 'vue';

withDefaults(
  defineProps<{
    showFooter?: boolean;
    hideCloseButton?: boolean;
  }>(),
  {
    showFooter: true,
    hideCloseButton: false,
  }
);

const { t } = i18n.global;
const mapStore = useMapStore();
const hazardsStore = useHazardsStore();

const selectedIncident = computed(() => {
  return hazardsStore.hazards?.incidents.find((incident) =>
    [mapStore.selectedPopupHazard?.hazardId, hazardsStore.selectedHazard?.hazardId].includes(incident.id)
  );
});

watch(selectedIncident, (incomingHazard, previousHazard) => {
  // This check ensures that we only close the popup when the hazard is removed,
  // not when it is changed to a different hazard (which happens when a user opens one popup, then another).
  const selectedHazardId = mapStore.selectedPopupHazard?.hazardId || hazardsStore.selectedHazard?.hazardId;

  if (incomingHazard || !previousHazard || selectedHazardId !== previousHazard?.id) return;

  mapStore.closePopup();
});

const zoomToFeatures = () => {
  mapStore.flyToFeatures(selectedIncident.value?.pointFeatures);
};
</script>
